// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-perfil{
    width: 100%;
    height: 100%;
    position: relative;
    /* background-color: rgb(1, 17, 31); */
    display: flex;
    justify-content: center;
    align-items: center;
}
.body{
  line-height: unset !important
}
.welcome-card{
    position: relative;
    top: 5px;
    left: 5px;
    width: 50%;
    height: 30%;
   background: transparent;
   /* border: 1px solid #dddddd; */
    /* background: rgba(255, 255, 255, .95); */
    /* background: linear-gradient(90deg, rgba(255,254,255,1) 0%, rgba(195,195,195,1) 100%); */
    -webkit-backdrop-filter: blur(24px);
            backdrop-filter: blur(24px);
    border-radius: 10px;
    
    display: block;
}
.top-welcome{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40%;
    width: 100%;
}
.mid-welcome{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20%;
    width: 100%;
}
.bottom-welcome{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20%;
    width: 100%;
    color: #757575;
}

.icon-perfil{
    position: relative;
    height: 80%;
    animation: swing 2s ease-in-out infinite;
    /* transform: rotate(90deg); */
}
.textTitle{
    font-family:"Roboto" !important;
    /* font-weight:l; */
    /* letter-spacing: 1px; */
    font-size: 24px;
    text-transform: capitalize;
}
.textTitleDark{
  font-family:"Roboto" !important;
 
  
  font-size: 24px;
  text-transform: capitalize;
  color: var(--white-color);
  
}
.footer-version{
    position: absolute;
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: medium;
  color: aliceblue;
  top: 90%;
}
.footer-mode{
  position: absolute;
  width: 10%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: medium;
  color: rgb(3, 136, 252);
  top: 0%;
  left: 90%;

}
@keyframes swing {
    0%, 100% {
        transform: rotate(0);
    }
    20% {
        transform: rotate(10deg);
    }
    40% {
        transform: rotate(-10deg);
    }
    60% {
        transform: rotate(10deg);
    }
    80% {
        transform: rotate(-10deg);
    }
  }
  .cont-load-main{
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
  }
.txt-load-main{
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
color: aliceblue;
font-size: 26px;
/* letter-spacing: 1px; */
font-style: italic;
animation: pulse-txt-main 5s infinite ease-in-out;
}
  .dots-container-main {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
  }
  
  .dots-main {
    height: 10px;
    width: 10px;
    margin-right: 10px;
    border-radius: 10px;
    background-color: #b3d4fc;
    animation: pulse-main 1.5s infinite ease-in-out;
    top: 30%;
    position: relative;
  }
  
  .dots-main:last-child {
    margin-right: 0;
  }
  
  .dots-main:nth-child(1) {
    animation-delay: -0.3s;
  }
  
  .dots-main:nth-child(2) {
    animation-delay: -0.1s;
  }
  
  .dots-main:nth-child(3) {
    animation-delay: 0.1s;
  }
  
  @keyframes pulse-main {
    0% {
        transform: scale(0.8);
        background-color: #b3d4fc;
        box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
      }
    
      50% {
        transform: scale(1.2);
        background-color: #6793fb;
        box-shadow: 0 0 0 10px rgba(178, 212, 252, 0);
      }
    
      100% {
        transform: scale(0.8);
        background-color: #b3d4fc;
        box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
      }
  }
  @keyframes pulse-txt-main {
    0% {
        transform: scale(0.9);
        /* color: #e6ffe0; */
        /* box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7); */
      }
    
      50% {
        transform: scale(1.1);
        /* color: #afffb6; */
        /* box-shadow: 0 0 0 10px rgba(178, 212, 252, 0); */
      }
    
      100% {
        transform: scale(0.9);
        /* color: #7afc80; */
        /* box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7); */
      }
  }

 /*******************************switch mode************************************/
 /* Default */
.theme {
  display: flex;
  align-items: center;
  -webkit-tap-highlight-color: transparent;
}

.theme__fill,
.theme__icon {
  transition: 0.3s;
}

.theme__fill {
  background-color: var(--bg);
  display: block;
  mix-blend-mode: difference;
  position: fixed;
  inset: 0;
  height: 100%;
  transform: translateX(-100%);
}

.theme__icon,
.theme__toggle {
  z-index: 1;
}

.theme__icon,
.theme__icon-part {
  position: absolute;
}

.theme__icon {
  display: block;
  top: 0.5em;
  left: 0.5em;
  width: 1.5em;
  height: 1.5em;
}

.theme__icon-part {
  border-radius: 50%;
  box-shadow: 0.4em -0.4em 0 0.5em hsl(0,0%,100%) inset;
  top: calc(50% - 0.5em);
  left: calc(50% - 0.5em);
  width: 1em;
  height: 1em;
  transition: box-shadow var(--transDur) ease-in-out,
		opacity var(--transDur) ease-in-out,
		transform var(--transDur) ease-in-out;
  transform: scale(0.5);
}

.theme__icon-part ~ .theme__icon-part {
  background-color: hsl(0,0%,100%);
  border-radius: 0.05em;
  top: 50%;
  left: calc(50% - 0.05em);
  transform: rotate(0deg) translateY(0.5em);
  transform-origin: 50% 0;
  width: 0.1em;
  height: 0.2em;
}

.theme__icon-part:nth-child(3) {
  transform: rotate(45deg) translateY(0.45em);
}

.theme__icon-part:nth-child(4) {
  transform: rotate(90deg) translateY(0.45em);
}

.theme__icon-part:nth-child(5) {
  transform: rotate(135deg) translateY(0.45em);
}

.theme__icon-part:nth-child(6) {
  transform: rotate(180deg) translateY(0.45em);
}

.theme__icon-part:nth-child(7) {
  transform: rotate(225deg) translateY(0.45em);
}

.theme__icon-part:nth-child(8) {
  transform: rotate(270deg) translateY(0.5em);
}

.theme__icon-part:nth-child(9) {
  transform: rotate(315deg) translateY(0.5em);
}

.theme__label,
.theme__toggle,
.theme__toggle-wrap {
  position: relative;
}

.theme__toggle,
.theme__toggle:before {
  display: block;
}

.theme__toggle {
  background-color: hsl(0, 0%, 99.2%);
  border-radius: 25% / 50%;
  box-shadow: 0 0 0 0.125em var(--primaryT);
  padding: 0.25em;
  width: 5.5em;
  height: 2.5em;
  appearance: none;
  transition: background-color var(--transDur) ease-in-out,
		box-shadow 0.15s ease-in-out,
		transform var(--transDur) ease-in-out;
    border: #a2a2a2 1px solid;
}
.theme__toggle-wrap:hover{
  cursor: pointer;
}
.theme__toggle:before {
  background-color: hsl(48,90%,55%);
  border-radius: 50%;
  content: "";
  width: 2em;
  height: 2em;
  transition: 0.3s;
}

.theme__toggle:focus {
  box-shadow: 0 0 0 0.125em var(--primary);
  outline: transparent;
}

/* Checked */
.theme__toggle:checked {
  background-color: hsl(198,90%,15%);
}

.theme__toggle:checked:before,
.theme__toggle:checked ~ .theme__icon {
  transform: translateX(3em);
}

.theme__toggle:checked:before {
  background-color: hsl(198,90%,55%);
}

.theme__toggle:checked ~ .theme__fill {
  /* transform: translateX(0); */
}

.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(1) {
  box-shadow: 0.2em -0.2em 0 0.2em hsl(0,0%,100%) inset;
  transform: scale(1);
  top: 0.2em;
  left: -0.2em;
}

.theme__toggle:checked ~ .theme__icon .theme__icon-part ~ .theme__icon-part {
  opacity: 0;
}

.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(2) {
  transform: rotate(45deg) translateY(0.8em);
}

.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(3) {
  transform: rotate(90deg) translateY(0.8em);
}

.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(4) {
  transform: rotate(135deg) translateY(0.8em);
}

.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(5) {
  transform: rotate(180deg) translateY(0.8em);
}

.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(6) {
  transform: rotate(225deg) translateY(0.8em);
}

.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(7) {
  transform: rotate(270deg) translateY(0.8em);
}

.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(8) {
  transform: rotate(315deg) translateY(0.8em);
}

.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(9) {
  transform: rotate(360deg) translateY(0.8em);
}

.theme__toggle-wrap {
  margin: 0 0.75em;
}

@supports selector(:focus-visible) {
  .theme__toggle:focus {
    box-shadow: 0 0 0 0.125em var(--primaryT);
  }

  .theme__toggle:focus-visible {
    box-shadow: 0 0 0 0.125em var(--primary);
  }
}



/*************************Switch languaje*************************/
/* From Uiverse.io by JaydipPrajapati1910 */ 
.btn-container-lang {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  text-align: center;
  position: absolute;
  top: 94%;
  left: 92%;
}

.btn-color-mode-switch {
  display: inline-block;
  margin: 0px;
  position: relative;
}

.btn-color-mode-switch > label.btn-color-mode-switch-inner {
  margin: 0px;
  /* width: 140px;
  height: 40px; */
  width: 90px;
  height: 30px;
  background-color: #1976D2;
  border-radius: 26px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease;
    /*box-shadow: 0px 0px 8px 0px rgba(17, 17, 17, 0.34) inset;*/
  display: block;
}

.btn-color-mode-switch > label.btn-color-mode-switch-inner:before {
  content: attr(data-on);
  position: absolute;
  font-size: 17px;
  font-weight: 600;
  top: 7px;
  right: 20px;
   color: #F5F7FB;
  
}

.btn-color-mode-switch > label.btn-color-mode-switch-inner:after {
  content: attr(data-off);
  width: 40px;
  height: 15px;
  background: #fff;
  border-radius: 26px;
  position: absolute;
  font-size: 17px;
  display: flex;
  justify-content: center;
  left: 2px;
  top: 2px;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0px 0px 6px -2px #111;
  padding: 5px 0px;
  color: #757575;
  font-weight: 600;
}

.btn-color-mode-switch input[type="checkbox"] {
  cursor: pointer;
  width: 90px;
  height: 25px;
  opacity: 0;
  position: absolute;
  top: 0;
  z-index: 1;
  margin: 0px;
  left: 0;
}

.btn-color-mode-switch input[type="checkbox"]:checked + label.btn-color-mode-switch-inner {
  background-color: #1976D2;
}

.btn-color-mode-switch input[type="checkbox"]:checked + label.btn-color-mode-switch-inner:after {
  content: attr(data-on);
  left: 48px;
}

.btn-color-mode-switch input[type="checkbox"]:checked + label.btn-color-mode-switch-inner:before {
  content: attr(data-off);
  right: auto;
  left: 20px;
}
/* **************************** horizontal Movil****************************** */
@media (max-width: 900px) {
  .btn-container-lang{
    right: 10%;
    left:85%;
    top:90%
  }
}

/* ****************************Movil****************************** */
@media (max-width: 500px) {
  .btn-container-lang{
    right: 10%;
    left:unset;
  }
  .txt-load-main{
    font-size: 12px;
  }
  .sidebarCont.btnLogout{
    width: 20% !important;
  }

}
`, "",{"version":3,"sources":["webpack://./src/sections/styles/perfil.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;EACE;AACF;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;GACZ,uBAAuB;GACvB,+BAA+B;IAC9B,0CAA0C;IAC1C,0FAA0F;IAC1F,mCAA2B;YAA3B,2BAA2B;IAC3B,mBAAmB;;IAEnB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,wCAAwC;IACxC,8BAA8B;AAClC;AACA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,0BAA0B;AAC9B;AACA;EACE,+BAA+B;;;EAG/B,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;;AAE3B;AACA;IACI,kBAAkB;EACpB,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,OAAO;EACP,SAAS;;AAEX;AACA;IACI;QACI,oBAAoB;IACxB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,yBAAyB;IAC7B;EACF;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;EACf;AACF;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,MAAM;AACV,gBAAgB;AAChB,eAAe;AACf,yBAAyB;AACzB,kBAAkB;AAClB,iDAAiD;AACjD;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,+CAA+C;IAC/C,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE;QACI,qBAAqB;QACrB,yBAAyB;QACzB,4CAA4C;MAC9C;;MAEA;QACE,qBAAqB;QACrB,yBAAyB;QACzB,6CAA6C;MAC/C;;MAEA;QACE,qBAAqB;QACrB,yBAAyB;QACzB,4CAA4C;MAC9C;EACJ;EACA;IACE;QACI,qBAAqB;QACrB,oBAAoB;QACpB,kDAAkD;MACpD;;MAEA;QACE,qBAAqB;QACrB,oBAAoB;QACpB,mDAAmD;MACrD;;MAEA;QACE,qBAAqB;QACrB,oBAAoB;QACpB,kDAAkD;MACpD;EACJ;;CAED,+EAA+E;CAC/E,YAAY;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX;;uCAEqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,QAAQ;EACR,wBAAwB;EACxB,yCAAyC;EACzC,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,yCAAyC;EACzC,eAAe;EACf,YAAY;EACZ,aAAa;EAEb,gBAAgB;EAChB;;uCAEqC;IACnC,yBAAyB;AAC7B;AACA;EACE,eAAe;AACjB;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA,YAAY;AACZ;EACE,kCAAkC;AACpC;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,yCAAyC;EAC3C;;EAEA;IACE,wCAAwC;EAC1C;AACF;;;;AAIA,kEAAkE;AAClE,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX;iBACe;EACf,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;IACvB,4DAA4D;EAC9D,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,WAAW;GACV,cAAc;;AAEjB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;EACX,OAAO;AACT;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,UAAU;AACZ;AACA,gFAAgF;AAChF;EACE;IACE,UAAU;IACV,QAAQ;IACR;EACF;AACF;;AAEA,oEAAoE;AACpE;EACE;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;;AAEF","sourcesContent":[".main-perfil{\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    /* background-color: rgb(1, 17, 31); */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.body{\r\n  line-height: unset !important\r\n}\r\n.welcome-card{\r\n    position: relative;\r\n    top: 5px;\r\n    left: 5px;\r\n    width: 50%;\r\n    height: 30%;\r\n   background: transparent;\r\n   /* border: 1px solid #dddddd; */\r\n    /* background: rgba(255, 255, 255, .95); */\r\n    /* background: linear-gradient(90deg, rgba(255,254,255,1) 0%, rgba(195,195,195,1) 100%); */\r\n    backdrop-filter: blur(24px);\r\n    border-radius: 10px;\r\n    \r\n    display: block;\r\n}\r\n.top-welcome{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 40%;\r\n    width: 100%;\r\n}\r\n.mid-welcome{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 20%;\r\n    width: 100%;\r\n}\r\n.bottom-welcome{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 20%;\r\n    width: 100%;\r\n    color: #757575;\r\n}\r\n\r\n.icon-perfil{\r\n    position: relative;\r\n    height: 80%;\r\n    animation: swing 2s ease-in-out infinite;\r\n    /* transform: rotate(90deg); */\r\n}\r\n.textTitle{\r\n    font-family:\"Roboto\" !important;\r\n    /* font-weight:l; */\r\n    /* letter-spacing: 1px; */\r\n    font-size: 24px;\r\n    text-transform: capitalize;\r\n}\r\n.textTitleDark{\r\n  font-family:\"Roboto\" !important;\r\n \r\n  \r\n  font-size: 24px;\r\n  text-transform: capitalize;\r\n  color: var(--white-color);\r\n  \r\n}\r\n.footer-version{\r\n    position: absolute;\r\n  width: 100%;\r\n  height: 10%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: medium;\r\n  color: aliceblue;\r\n  top: 90%;\r\n}\r\n.footer-mode{\r\n  position: absolute;\r\n  width: 10%;\r\n  height: 10%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: medium;\r\n  color: rgb(3, 136, 252);\r\n  top: 0%;\r\n  left: 90%;\r\n\r\n}\r\n@keyframes swing {\r\n    0%, 100% {\r\n        transform: rotate(0);\r\n    }\r\n    20% {\r\n        transform: rotate(10deg);\r\n    }\r\n    40% {\r\n        transform: rotate(-10deg);\r\n    }\r\n    60% {\r\n        transform: rotate(10deg);\r\n    }\r\n    80% {\r\n        transform: rotate(-10deg);\r\n    }\r\n  }\r\n  .cont-load-main{\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    display: flex;\r\n  }\r\n.txt-load-main{\r\n    position: absolute;\r\n    height: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    top: 0;\r\ncolor: aliceblue;\r\nfont-size: 26px;\r\n/* letter-spacing: 1px; */\r\nfont-style: italic;\r\nanimation: pulse-txt-main 5s infinite ease-in-out;\r\n}\r\n  .dots-container-main {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n  \r\n  .dots-main {\r\n    height: 10px;\r\n    width: 10px;\r\n    margin-right: 10px;\r\n    border-radius: 10px;\r\n    background-color: #b3d4fc;\r\n    animation: pulse-main 1.5s infinite ease-in-out;\r\n    top: 30%;\r\n    position: relative;\r\n  }\r\n  \r\n  .dots-main:last-child {\r\n    margin-right: 0;\r\n  }\r\n  \r\n  .dots-main:nth-child(1) {\r\n    animation-delay: -0.3s;\r\n  }\r\n  \r\n  .dots-main:nth-child(2) {\r\n    animation-delay: -0.1s;\r\n  }\r\n  \r\n  .dots-main:nth-child(3) {\r\n    animation-delay: 0.1s;\r\n  }\r\n  \r\n  @keyframes pulse-main {\r\n    0% {\r\n        transform: scale(0.8);\r\n        background-color: #b3d4fc;\r\n        box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);\r\n      }\r\n    \r\n      50% {\r\n        transform: scale(1.2);\r\n        background-color: #6793fb;\r\n        box-shadow: 0 0 0 10px rgba(178, 212, 252, 0);\r\n      }\r\n    \r\n      100% {\r\n        transform: scale(0.8);\r\n        background-color: #b3d4fc;\r\n        box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);\r\n      }\r\n  }\r\n  @keyframes pulse-txt-main {\r\n    0% {\r\n        transform: scale(0.9);\r\n        /* color: #e6ffe0; */\r\n        /* box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7); */\r\n      }\r\n    \r\n      50% {\r\n        transform: scale(1.1);\r\n        /* color: #afffb6; */\r\n        /* box-shadow: 0 0 0 10px rgba(178, 212, 252, 0); */\r\n      }\r\n    \r\n      100% {\r\n        transform: scale(0.9);\r\n        /* color: #7afc80; */\r\n        /* box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7); */\r\n      }\r\n  }\r\n\r\n /*******************************switch mode************************************/\r\n /* Default */\r\n.theme {\r\n  display: flex;\r\n  align-items: center;\r\n  -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\n.theme__fill,\r\n.theme__icon {\r\n  transition: 0.3s;\r\n}\r\n\r\n.theme__fill {\r\n  background-color: var(--bg);\r\n  display: block;\r\n  mix-blend-mode: difference;\r\n  position: fixed;\r\n  inset: 0;\r\n  height: 100%;\r\n  transform: translateX(-100%);\r\n}\r\n\r\n.theme__icon,\r\n.theme__toggle {\r\n  z-index: 1;\r\n}\r\n\r\n.theme__icon,\r\n.theme__icon-part {\r\n  position: absolute;\r\n}\r\n\r\n.theme__icon {\r\n  display: block;\r\n  top: 0.5em;\r\n  left: 0.5em;\r\n  width: 1.5em;\r\n  height: 1.5em;\r\n}\r\n\r\n.theme__icon-part {\r\n  border-radius: 50%;\r\n  box-shadow: 0.4em -0.4em 0 0.5em hsl(0,0%,100%) inset;\r\n  top: calc(50% - 0.5em);\r\n  left: calc(50% - 0.5em);\r\n  width: 1em;\r\n  height: 1em;\r\n  transition: box-shadow var(--transDur) ease-in-out,\r\n\t\topacity var(--transDur) ease-in-out,\r\n\t\ttransform var(--transDur) ease-in-out;\r\n  transform: scale(0.5);\r\n}\r\n\r\n.theme__icon-part ~ .theme__icon-part {\r\n  background-color: hsl(0,0%,100%);\r\n  border-radius: 0.05em;\r\n  top: 50%;\r\n  left: calc(50% - 0.05em);\r\n  transform: rotate(0deg) translateY(0.5em);\r\n  transform-origin: 50% 0;\r\n  width: 0.1em;\r\n  height: 0.2em;\r\n}\r\n\r\n.theme__icon-part:nth-child(3) {\r\n  transform: rotate(45deg) translateY(0.45em);\r\n}\r\n\r\n.theme__icon-part:nth-child(4) {\r\n  transform: rotate(90deg) translateY(0.45em);\r\n}\r\n\r\n.theme__icon-part:nth-child(5) {\r\n  transform: rotate(135deg) translateY(0.45em);\r\n}\r\n\r\n.theme__icon-part:nth-child(6) {\r\n  transform: rotate(180deg) translateY(0.45em);\r\n}\r\n\r\n.theme__icon-part:nth-child(7) {\r\n  transform: rotate(225deg) translateY(0.45em);\r\n}\r\n\r\n.theme__icon-part:nth-child(8) {\r\n  transform: rotate(270deg) translateY(0.5em);\r\n}\r\n\r\n.theme__icon-part:nth-child(9) {\r\n  transform: rotate(315deg) translateY(0.5em);\r\n}\r\n\r\n.theme__label,\r\n.theme__toggle,\r\n.theme__toggle-wrap {\r\n  position: relative;\r\n}\r\n\r\n.theme__toggle,\r\n.theme__toggle:before {\r\n  display: block;\r\n}\r\n\r\n.theme__toggle {\r\n  background-color: hsl(0, 0%, 99.2%);\r\n  border-radius: 25% / 50%;\r\n  box-shadow: 0 0 0 0.125em var(--primaryT);\r\n  padding: 0.25em;\r\n  width: 5.5em;\r\n  height: 2.5em;\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  transition: background-color var(--transDur) ease-in-out,\r\n\t\tbox-shadow 0.15s ease-in-out,\r\n\t\ttransform var(--transDur) ease-in-out;\r\n    border: #a2a2a2 1px solid;\r\n}\r\n.theme__toggle-wrap:hover{\r\n  cursor: pointer;\r\n}\r\n.theme__toggle:before {\r\n  background-color: hsl(48,90%,55%);\r\n  border-radius: 50%;\r\n  content: \"\";\r\n  width: 2em;\r\n  height: 2em;\r\n  transition: 0.3s;\r\n}\r\n\r\n.theme__toggle:focus {\r\n  box-shadow: 0 0 0 0.125em var(--primary);\r\n  outline: transparent;\r\n}\r\n\r\n/* Checked */\r\n.theme__toggle:checked {\r\n  background-color: hsl(198,90%,15%);\r\n}\r\n\r\n.theme__toggle:checked:before,\r\n.theme__toggle:checked ~ .theme__icon {\r\n  transform: translateX(3em);\r\n}\r\n\r\n.theme__toggle:checked:before {\r\n  background-color: hsl(198,90%,55%);\r\n}\r\n\r\n.theme__toggle:checked ~ .theme__fill {\r\n  /* transform: translateX(0); */\r\n}\r\n\r\n.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(1) {\r\n  box-shadow: 0.2em -0.2em 0 0.2em hsl(0,0%,100%) inset;\r\n  transform: scale(1);\r\n  top: 0.2em;\r\n  left: -0.2em;\r\n}\r\n\r\n.theme__toggle:checked ~ .theme__icon .theme__icon-part ~ .theme__icon-part {\r\n  opacity: 0;\r\n}\r\n\r\n.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(2) {\r\n  transform: rotate(45deg) translateY(0.8em);\r\n}\r\n\r\n.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(3) {\r\n  transform: rotate(90deg) translateY(0.8em);\r\n}\r\n\r\n.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(4) {\r\n  transform: rotate(135deg) translateY(0.8em);\r\n}\r\n\r\n.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(5) {\r\n  transform: rotate(180deg) translateY(0.8em);\r\n}\r\n\r\n.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(6) {\r\n  transform: rotate(225deg) translateY(0.8em);\r\n}\r\n\r\n.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(7) {\r\n  transform: rotate(270deg) translateY(0.8em);\r\n}\r\n\r\n.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(8) {\r\n  transform: rotate(315deg) translateY(0.8em);\r\n}\r\n\r\n.theme__toggle:checked ~ .theme__icon .theme__icon-part:nth-child(9) {\r\n  transform: rotate(360deg) translateY(0.8em);\r\n}\r\n\r\n.theme__toggle-wrap {\r\n  margin: 0 0.75em;\r\n}\r\n\r\n@supports selector(:focus-visible) {\r\n  .theme__toggle:focus {\r\n    box-shadow: 0 0 0 0.125em var(--primaryT);\r\n  }\r\n\r\n  .theme__toggle:focus-visible {\r\n    box-shadow: 0 0 0 0.125em var(--primary);\r\n  }\r\n}\r\n\r\n\r\n\r\n/*************************Switch languaje*************************/\r\n/* From Uiverse.io by JaydipPrajapati1910 */ \r\n.btn-container-lang {\r\n  display: table-cell;\r\n  vertical-align: middle;\r\n  text-align: center;\r\n  text-align: center;\r\n  position: absolute;\r\n  top: 94%;\r\n  left: 92%;\r\n}\r\n\r\n.btn-color-mode-switch {\r\n  display: inline-block;\r\n  margin: 0px;\r\n  position: relative;\r\n}\r\n\r\n.btn-color-mode-switch > label.btn-color-mode-switch-inner {\r\n  margin: 0px;\r\n  /* width: 140px;\r\n  height: 40px; */\r\n  width: 90px;\r\n  height: 30px;\r\n  background-color: #1976D2;\r\n  border-radius: 26px;\r\n  overflow: hidden;\r\n  position: relative;\r\n  transition: all 0.3s ease;\r\n    /*box-shadow: 0px 0px 8px 0px rgba(17, 17, 17, 0.34) inset;*/\r\n  display: block;\r\n}\r\n\r\n.btn-color-mode-switch > label.btn-color-mode-switch-inner:before {\r\n  content: attr(data-on);\r\n  position: absolute;\r\n  font-size: 17px;\r\n  font-weight: 600;\r\n  top: 7px;\r\n  right: 20px;\r\n   color: #F5F7FB;\r\n  \r\n}\r\n\r\n.btn-color-mode-switch > label.btn-color-mode-switch-inner:after {\r\n  content: attr(data-off);\r\n  width: 40px;\r\n  height: 15px;\r\n  background: #fff;\r\n  border-radius: 26px;\r\n  position: absolute;\r\n  font-size: 17px;\r\n  display: flex;\r\n  justify-content: center;\r\n  left: 2px;\r\n  top: 2px;\r\n  text-align: center;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0px 0px 6px -2px #111;\r\n  padding: 5px 0px;\r\n  color: #757575;\r\n  font-weight: 600;\r\n}\r\n\r\n.btn-color-mode-switch input[type=\"checkbox\"] {\r\n  cursor: pointer;\r\n  width: 90px;\r\n  height: 25px;\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 0;\r\n  z-index: 1;\r\n  margin: 0px;\r\n  left: 0;\r\n}\r\n\r\n.btn-color-mode-switch input[type=\"checkbox\"]:checked + label.btn-color-mode-switch-inner {\r\n  background-color: #1976D2;\r\n}\r\n\r\n.btn-color-mode-switch input[type=\"checkbox\"]:checked + label.btn-color-mode-switch-inner:after {\r\n  content: attr(data-on);\r\n  left: 48px;\r\n}\r\n\r\n.btn-color-mode-switch input[type=\"checkbox\"]:checked + label.btn-color-mode-switch-inner:before {\r\n  content: attr(data-off);\r\n  right: auto;\r\n  left: 20px;\r\n}\r\n/* **************************** horizontal Movil****************************** */\r\n@media (max-width: 900px) {\r\n  .btn-container-lang{\r\n    right: 10%;\r\n    left:85%;\r\n    top:90%\r\n  }\r\n}\r\n\r\n/* ****************************Movil****************************** */\r\n@media (max-width: 500px) {\r\n  .btn-container-lang{\r\n    right: 10%;\r\n    left:unset;\r\n  }\r\n  .txt-load-main{\r\n    font-size: 12px;\r\n  }\r\n  .sidebarCont.btnLogout{\r\n    width: 20% !important;\r\n  }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
